export enum OffsiteCampaignRoute {
  HOME = '/sites/:siteId/campaigns',
  OFFSITE_LIST = '/sites/:siteId/campaigns/offsite',
  OFFSITE_EDIT = '/sites/:siteId/campaigns/offsite/:campaignId',
  CREATE_OFFSITE_WIZARD_PAGE = '/sites/:siteId/campaigns/offsite/newcampaign/:campaignWizardPage/',
}
